/* WOW Store — ficha de producto: variantes, galería por color/modelo, packs mezclables, carrito y barra fija. */
(() => {
  const reduceMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();

  function fmt(cents) {
    const format = window.wsMoneyFormat || '{{amount_with_comma_separator}} €';
    const sep = (value, dec, th) => {
      const [i, d] = Number(value).toFixed(2).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (dec ? dec + d : '');
    };
    const n = cents / 100;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return sep(n, '.', ',');
        case 'amount_no_decimals': return sep(Math.round(n), '', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(Math.round(n), '', '.');
        default: return sep(n, ',', '.');
      }
    });
  }

  class WsProduct {
    constructor(root) {
      this.root = root;
      this.variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      this.form = root.querySelector('.ws-pdp__form');
      this.input = root.querySelector('[data-variant-input]');
      this.addBtn = root.querySelector('[data-add]');
      this.error = root.querySelector('[data-error]');
      this.summary = root.querySelector('[data-units-summary]');
      this.addHTML = this.addBtn ? this.addBtn.innerHTML : '';

      const packFs = root.querySelector('[data-pack-option]');
      this.packIndex = packFs ? Number(packFs.dataset.option) : -1;
      this.visIndex = root.hasAttribute('data-vis') ? Number(root.dataset.vis) : -1;
      this.mix = root.hasAttribute('data-mix');
      this.basePack = root.dataset.basePack;
      this.lastVal = null;

      root.querySelectorAll('[data-opt-input]').forEach((i) => i.addEventListener('change', () => this.refresh()));
      root.querySelectorAll('[data-unit-input]').forEach((i) =>
        i.addEventListener('change', () => {
          this.lastVal = i.value;
          this.refresh();
        })
      );

      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.add(this.cartItems(), this.addBtn);
        });
      }
      root.querySelectorAll('[data-quick-add]').forEach((b) =>
        b.addEventListener('click', () => this.add([{ id: Number(b.dataset.quickAdd), quantity: 1 }], b, true))
      );

      this.initGallery();
      this.initSticky();
      this.refresh(true);
    }

    /* ---------- Variantes ---------- */
    unitsCount() {
      const p = this.root.querySelector('[data-pack-option] input:checked');
      return p ? Number(p.dataset.units) || 1 : 1;
    }

    unitValues() {
      const n = this.unitsCount();
      return [...this.root.querySelectorAll('[data-unit]')]
        .slice(0, n)
        .map((fs) => (fs.querySelector('input:checked') || {}).value);
    }

    singles() {
      return this.unitValues().map((val) => {
        const o = [];
        o[this.packIndex] = this.basePack;
        o[this.visIndex] = val;
        return this.find(o);
      });
    }

    selected() {
      if (this.mix) {
        const opts = [];
        const p = this.root.querySelector('[data-pack-option] input:checked');
        opts[this.packIndex] = p && p.value;
        opts[this.visIndex] = this.unitValues()[0];
        return opts;
      }
      return [...this.root.querySelectorAll('[data-option]')]
        .sort((a, b) => Number(a.dataset.option) - Number(b.dataset.option))
        .map((fs) => (fs.querySelector('input:checked') || {}).value);
    }

    find(opts) {
      return this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    /* Packs mezclables: precio real = suma de las unidades elegidas − ahorro del pack.
       El ahorro sale de los precios de las variantes (unidad × n − pack), el mismo que aplica el descuento automático. */
    allUnitValues() {
      return [...this.root.querySelectorAll('[data-unit]')].map((fs) => (fs.querySelector('input:checked') || {}).value);
    }

    packValueFor(n) {
      const inp = [...this.root.querySelectorAll('[data-pack-option] input')].find((i) => Number(i.dataset.units) === n);
      return inp ? inp.value : null;
    }

    single(val) {
      const o = [];
      o[this.packIndex] = this.basePack;
      o[this.visIndex] = val;
      return this.find(o);
    }

    mixTotal(n) {
      const vals = this.allUnitValues();
      const first = vals[0];
      let sum = 0;
      for (let k = 0; k < n; k++) {
        const s = this.single(vals[k] || first);
        if (!s) return null;
        sum += s.price;
      }
      if (n <= 1) return sum;
      const packVal = this.packValueFor(n);
      const base = this.single(first);
      const o = [];
      o[this.packIndex] = packVal;
      o[this.visIndex] = first;
      const pack = packVal ? this.find(o) : null;
      const saving = base && pack ? Math.max(0, base.price * n - pack.price) : 0;
      return sum - saving;
    }

    // Suma de las unidades sueltas elegidas (sin ahorro): es el precio tachado.
    mixSum(n) {
      const vals = this.allUnitValues();
      let sum = 0;
      for (let k = 0; k < n; k++) {
        const s = this.single(vals[k] || vals[0]);
        if (!s) return 0;
        sum += s.price;
      }
      return sum;
    }

    firstUnits() {
      const first = this.root.querySelector('[data-pack-option] input');
      return first ? Number(first.dataset.units) || 1 : 1;
    }

    // Tarjeta de pack: precio, precio tachado, ahorro con % y precio por unidad (todo calculado de los precios reales).
    paintPack(inp, total, full, n) {
      const card = inp.closest('label');
      if (!card || total === null || total === undefined) return;
      const q = (sel) => card.querySelector(sel);
      const price = q('[data-pack-price]');
      if (price) price.textContent = fmt(total);
      const save = full > total ? full - total : 0;
      const cmp = q('[data-pack-compare]');
      if (cmp) {
        cmp.textContent = fmt(full);
        cmp.hidden = !save;
      }
      const sv = q('[data-pack-save]');
      if (sv) {
        sv.hidden = !save;
        if (save) sv.textContent = 'Ahorras ' + fmt(save) + ' · −' + Math.round((save * 100) / full) + ' %';
      }
      const unit = q('[data-pack-unit]');
      if (unit && n > 1) unit.textContent = fmt(Math.round(total / n)) + ' por unidad';
    }

    cartItems() {
      if (!this.mix) return [{ id: Number(this.input.value), quantity: 1 }];
      const qty = new Map();
      this.singles().forEach((s) => {
        if (s) qty.set(s.id, (qty.get(s.id) || 0) + 1);
      });
      return [...qty].map(([id, quantity]) => ({ id, quantity }));
    }

    refresh(initial) {
      if (this.mix) {
        const n = this.unitsCount();
        this.root.querySelectorAll('[data-unit]').forEach((fs, k) => (fs.hidden = k >= n));
      }

      const opts = this.selected();
      opts.forEach((val, i) => {
        const l = this.root.querySelector(`[data-opt-label="${i}"]`);
        if (l) l.textContent = val;
      });

      const packFs = this.root.querySelector('[data-pack-option]');
      if (packFs && !this.mix) {
        packFs.querySelectorAll('input').forEach((inp) => {
          const o = [...opts];
          o[this.packIndex] = inp.value;
          const pv = this.find(o);
          const n = Number(inp.dataset.units) || 1;
          const b = [...opts];
          b[this.packIndex] = this.packValueFor(this.firstUnits());
          const base = this.find(b);
          const full = base ? Math.round((base.price * n) / this.firstUnits()) : 0;
          if (pv) this.paintPack(inp, pv.price, full, n);
          inp.disabled = !pv || !pv.available;
        });
      }

      const v = this.find(opts);
      if (!v) {
        this.setBtn(false, 'No disponible');
        return;
      }

      let available = v.available;
      let price = v.price;
      if (this.mix) {
        const s = this.singles();
        available = s.length > 0 && s.every((x) => x && x.available);
        if (this.summary) this.summary.textContent = 'Tu selección: ' + this.unitValues().join(' + ');
        const total = this.mixTotal(this.unitsCount());
        if (total !== null) price = total;
        if (packFs) {
          packFs.querySelectorAll('input').forEach((inp) => {
            const n = Number(inp.dataset.units) || 1;
            this.paintPack(inp, this.mixTotal(n), this.mixSum(n), n);
          });
        }
      }

      this.input.value = v.id;
      this.root.querySelectorAll('[data-price],[data-add-price],[data-sticky-price]').forEach((el) => (el.textContent = fmt(price)));
      this.setBtn(available, 'Agotado');
      this.applyGallery(opts, initial);

      if (!this.mix && !initial) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    setBtn(available, label) {
      if (!this.addBtn) return;
      this.addBtn.disabled = !available;
      if (available) {
        const price = this.root.querySelector('[data-price]');
        this.addBtn.innerHTML = this.addHTML;
        const ap = this.addBtn.querySelector('[data-add-price]');
        if (ap && price) ap.textContent = price.textContent;
      } else {
        this.addBtn.textContent = label;
      }
    }

    /* ---------- Galería ---------- */
    initGallery() {
      this.track = this.root.querySelector('[data-track]');
      this.slides = this.track ? [...this.track.children] : [];
      this.thumbs = [...this.root.querySelectorAll('[data-thumb]')];
      this.count = this.root.querySelector('[data-count]');
      this.visible = this.slides.slice();
      this.current = 0;
      if (!this.track) return;

      // Valores de color/modelo reales del producto.
      const valid = new Set();
      if (this.visIndex >= 0) this.variants.forEach((v) => valid.add(norm(v.options[this.visIndex])));

      // Cada foto: colores a los que pertenece (asignación nativa de Shopify + texto alternativo exacto).
      this.slides.forEach((s) => {
        const raw = [...String(s.dataset.values || '').split('|'), ...String(s.dataset.alt || '').split(/[|,]/)];
        s._vals = [...new Set(raw.map(norm).filter((x) => x && valid.has(x)))];
      });

      this.thumbs.forEach((t) =>
        t.addEventListener('click', () => {
          const i = this.visible.indexOf(this.slides[Number(t.dataset.thumb)]);
          if (i >= 0) this.goTo(i);
        })
      );

      let raf;
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
            if (i !== this.current) this.mark(i);
          });
        },
        { passive: true }
      );
    }

    // Colores elegidos y color a enfocar.
    galleryState(opts) {
      if (this.visIndex < 0) return null;
      if (this.mix) {
        const vals = this.unitValues().filter(Boolean);
        const chosen = [...new Set(vals)];
        const focus = this.lastVal && chosen.includes(this.lastVal) ? this.lastVal : chosen[0];
        return { chosen, focus };
      }
      return { chosen: [opts[this.visIndex]], focus: opts[this.visIndex] };
    }

    applyGallery(opts, instant) {
      if (!this.track || !this.slides.length) return;
      const state = this.galleryState(opts);
      let target = 0;

      if (state) {
        const chosen = state.chosen.map(norm);
        const match = (s) => s._vals.some((x) => chosen.includes(x));
        // Si ningún color elegido tiene fotos propias, se muestran todas (no se inventa nada).
        const showAll = !this.slides.some(match);
        this.slides.forEach((s, i) => {
          const vis = showAll || !s._vals.length || match(s);
          s.hidden = !vis;
          if (this.thumbs[i]) this.thumbs[i].hidden = !vis;
        });
        this.visible = this.slides.filter((s) => !s.hidden);

        // Foto a mostrar: primero la asignada de forma nativa a la variante; si no, la etiquetada con ese color.
        const f = norm(state.focus);
        const fv =
          this.variants.find((v) => norm(v.options[this.visIndex]) === f && v.featured_media && v.options[this.packIndex] === this.basePack) ||
          this.variants.find((v) => norm(v.options[this.visIndex]) === f && v.featured_media);
        let i = fv ? this.visible.findIndex((s) => s.dataset.mediaId === String(fv.featured_media.id)) : -1;
        if (i < 0) i = this.visible.findIndex((s) => s._vals.includes(f));
        target = i < 0 ? 0 : i;
      }
      // Al abrir la ficha se enseña la foto principal; la foto de la opción solo al elegirla (o si viene en el enlace).
      if (instant && !new URL(window.location.href).searchParams.has('variant')) target = 0;
      this.goTo(target, instant);
    }

    goTo(i, instant) {
      if (!this.track) return;
      const behavior = instant || reduceMotion() ? 'auto' : 'smooth';
      if (typeof this.track.scrollTo === 'function') this.track.scrollTo({ left: i * this.track.clientWidth, behavior });
      this.mark(i);
    }

    mark(i) {
      this.current = i;
      const slide = this.visible[i];
      const abs = this.slides.indexOf(slide);
      this.thumbs.forEach((t, k) => {
        const on = k === abs;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (this.count) {
        this.count.textContent = `${i + 1} / ${this.visible.length}`;
        this.count.hidden = this.visible.length < 2;
      }
      const thumb = this.thumbs[abs];
      const row = thumb && thumb.parentElement;
      if (row && typeof row.scrollTo === 'function') {
        row.scrollTo({ left: thumb.offsetLeft - row.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'auto' });
      }
    }

    /* ---------- Carrito ---------- */
    showError(msg) {
      if (!this.error) return;
      this.error.textContent = msg;
      this.error.hidden = false;
    }

    async add(items, btn, isQuick) {
      if (this.error) this.error.hidden = true;
      if (!items.length) return this.showError('Elige una opción para cada unidad.');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      try {
        const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(base + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se ha podido añadir al carrito.');
        if (isQuick) {
          btn.classList.add('is-done');
          btn.textContent = 'Añadido';
        }
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        this.showError(e.message);
      } finally {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }
    }

    initSticky() {
      const bar = this.root.querySelector('[data-sticky]');
      if (!bar || !this.addBtn || !('IntersectionObserver' in window)) return;
      const btn = bar.querySelector('[data-sticky-add]');
      btn.addEventListener('click', () => {
        if (this.addBtn.disabled) {
          this.addBtn.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        this.add(this.cartItems(), btn);
      });
      new IntersectionObserver(([entry]) => {
        const on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
      }).observe(this.addBtn);
    }
  }

  const init = (scope) =>
    scope.querySelectorAll('[data-ws-product]').forEach((el) => {
      if (!el.wsProduct) el.wsProduct = new WsProduct(el);
    });
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  window.WsProduct = WsProduct;
})();
